import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { CountrySelectionService } from '../services/country-selection/country-selection.service';

@Injectable()
export class ErrorHandlingInterceptor implements HttpInterceptor {
  private readonly errorCodes: number[] = [401, 403];
  constructor(private readonly _countrySelectionService: CountrySelectionService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.errorCodes.includes(+error.status)) {
          this.handleAuthorizationErrors(error);
            return throwError(() => error);
        } else {
          
          return throwError(() => error);
        }
      })
    );
  }

  public handleAuthorizationErrors(httpError: HttpErrorResponse): void {
    const error = httpError.error;
    const ignoreBackendCodes = ["8010", "1803"]
    if (error && error['error-code'] && ignoreBackendCodes.includes(error['error-code'])) {
      throwError(() => httpError);
    } else {
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('currentCIAMUser');
      localStorage.removeItem('countryOfOrigin')
      this._countrySelectionService.triggerCountrySelection();
      // this.authAmplifyService.manageLoginResponse();
    }
  }

   //  Avoid to pass the real errors to client
   private displayServerErrorMessage(error: HttpErrorResponse): any {
    switch (error.status) {
      case 403: {
        return `Unauthorized access`;
      }
      case 500: {
        return `Resource not found`;
      }
      case 400: {
        return `Cluster not available for the tour `;
      }
    }
  }

}
